<template>
  <router-view></router-view>
</template>
<script>
import { ElLoading } from "element-plus";

export default {
  name: "App",
}

//定义加载动画实例
const loadingInstance = ElLoading.service({
  fullscreen: true,
  // spinner:'Eleme',
  text: "正在加载",
  background: "white",
});
//获取页面加载完成状态，vue调试模式下会获取不到完成事件，如果是静态刷新，则加载完成后提前结束
document.onreadystatechange = function () {
  if (document.readyState == "complete") {
    setTimeout(() => {
      loadingInstance.close();
    }, 500);
    // document
    //   .getElementById("name-img")
    //   .setAttribute(
    //     "style",
    //     "animation: OutBottom 1s ease 0.3s 1 forwards;z-index:99"
    //   );
  }
};
// 2000ms后自动结束加载动画
setTimeout(() => {
  loadingInstance.close();
  // document
  //   .getElementById("name-img")
  //   .setAttribute(
  //     "style",
  //     "animation: OutBottom 1s ease 0.3s 1 forwards;z-index:99"
  //   );
}, 2000);
</script>